/**
 * lockScroll()
 *
 * Locks body scroll while preserving the current scroll position. Reference-
 * counted so nested overlays (drawer + search) don't unlock prematurely.
 * Uses overflow:hidden on <html> + scrollbar-gutter to avoid layout shift.
 */

let lockCount = 0;
let cachedScrollY = 0;

/** @returns {() => void} unlock */
export function lockScroll() {
  if (lockCount === 0) {
    cachedScrollY = window.scrollY;
    const html = document.documentElement;
    const body = document.body;
    const scrollbarWidth = window.innerWidth - html.clientWidth;
    html.style.setProperty('overflow', 'hidden');
    body.style.setProperty('overflow', 'hidden');
    if (scrollbarWidth > 0) {
      body.style.setProperty('padding-right', `${scrollbarWidth}px`);
    }
  }
  lockCount += 1;

  let released = false;
  return function unlock() {
    if (released) return;
    released = true;
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      const html = document.documentElement;
      const body = document.body;
      html.style.removeProperty('overflow');
      body.style.removeProperty('overflow');
      body.style.removeProperty('padding-right');
      window.scrollTo(0, cachedScrollY);
    }
  };
}
